import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';

var fconnectSignupform = function (classname, form) {
  const $form = $(form);
  const formtype = $form.attr('id');
  const geoLocation = LocationUtilities.getGeoLocation();
  if (formtype === 'fconnect_signup') {
    $('.' + classname).find('.button').addClass('button--loading').attr('disabled', 'disabled');
    setTimeout(function () {
      $form.find('.button').removeClass('button--loading');
      $('#detailPlan').modal('show');
      $('#fconnect_signup .thank-you-card ').addClass('active');
      $('#detailPlan h3').removeClass('active');
      $form.trigger('reset');
      $form.find('.form-field').each(function () {
        $(this).find('.form-placeholder').removeClass('placeholder-fix');
      });
      // $('.email-only-form-wrapper h2, .email-only-form-wrapper form, .email-only-form-wrapper p, .email-only-form-wrapper .thank-you-card').addClass('active');
    }, 1000);
  }
  if (formtype === 'fconnect_shareinfo') {
    const fmListId = $form.find('.fm-list-id').val();
    const emailid = $form.find('input[name^="email"]').val();
    const emailHash = SiteUtilities.getShaHash(emailid);
    const fdeskDomain = '.freshdesk.com';
    const fsalesDomain = '.freshsales.io';
    $('.' + classname).find('.button').addClass('button--loading').attr('disabled', 'disabled');
    if (fmListId) {
      // Freshmarketer Data
      const freshmarketerData = {
        freshmarketerObject: {
          email: emailid,
          country: geoLocation ? geoLocation.countryName : '',
          contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
          custom_field: {
            cf_fdeskaccounturl: $form.find('input[name="fdesk-helpdesk"]').val() + fdeskDomain,
            cf_fsalesaccounturl: $form.find('input[name="fsales-helpdesk"]').val() + fsalesDomain,
            cf_freshmarketer_list: fmListId
          }
        }
      };
      SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
    }
    // We are not posting to Freshmarketer as freshdesk, freshsales leads can be segregated as leads from Freshconnect through the Signup Referrer.
    setTimeout(function () {
      $form.find('.button').removeClass('button--loading');
      $('#shareInfo').modal('show');
      $('#fconnect_signup .thank-you-card ').addClass('active');
      $('#shareInfo h3').removeClass('active');
      $form.trigger('reset');
      $form.find('.form-field').each(function () {
        $(this).find('.form-placeholder').removeClass('placeholder-fix');
      });
    }, 1000);
    try {
      const pageName = window.location.href;
      const trackers = ga.getAll();
      const tracker = trackers.find(element => element.get('trackingId') === 'UA-125045345-1');
      const trackerName = tracker.get('name');
      const ehashParam = pageName.match(/\?./) ? `&ehash=${emailHash}` : `?ehash=${emailHash}`;
      ga(trackerName + '.set', {
        page: pageName + ehashParam,
        title: 'Freshconnect - Share Info Form'
      });
      ga(trackerName + '.send', 'pageview', {
        page: pageName + ehashParam,
        title: 'Freshconnect - Share Info Form'
      });
    } catch (e) {
      SiteUtilities.log(e.message, 'error', 'fconnect-form-handler.fconnectSignupForm.try-catch', 2, e);
    }
  }
};

var fconnectLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('.domain-form').val();
  const subPath = $form.attr('data-custom-subpath');
  // There is no API to check if the account exists yet.
  let redirectUrl = `https://${domain}.freshconnect.io`;
  if (subPath && subPath.match(/^([a-zA-Z1-9/]+)$/)) {
    redirectUrl = redirectUrl + '/' + subPath;
  }
  window.location.href = redirectUrl;
  GA4Utilities.loginFormSubmit(domain);
};

var fconnectForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = 'https://api.freshconnect.io/api/v3/users/forgot-domain';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const data = {
    email
  };
  $.ajax({
    url: forgotDomainUrl,
    contentType: 'application/json',
    type: 'PUT',
    data: JSON.stringify(data),
    success: (response) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.find('.email-form').parents('.form-field').addClass('error');
      $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
    }
  });
};

export default {
  fconnectSignupform,
  fconnectLoginForm,
  fconnectForgotDomainForm
};
